import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { resendOtp } from '../../api/apiOtp';

/**
 * Hook for resending OTP codes
 * Manages cooldown state to prevent spam
 * @returns {Object} Mutation object with cooldown state
 */
export const useOtpResend = () => {
    const [cooldownSeconds, setCooldownSeconds] = useState(0);
    const [canResend, setCanResend] = useState(true);

    const mutation = useMutation({
        mutationFn: ({ channel, identifier, purpose }) => {
            return resendOtp(channel, identifier, purpose);
        },
        onSuccess: (data) => {
            // Set new cooldown period
            if (data?.data?.cooldown_seconds) {
                setCooldownSeconds(data.data.cooldown_seconds);
                setCanResend(false);

                // Auto-enable resend after cooldown
                setTimeout(() => {
                    setCanResend(true);
                    setCooldownSeconds(0);
                }, data.data.cooldown_seconds * 1000);
            }
        },
        onError: (error) => {
            // Handle cooldown from error response (429)
            if (error?.response?.status === 429) {
                const retryAfter = error.response.data?.meta?.retry_after ||
                    error.response.data?.meta?.remaining_seconds;
                if (retryAfter) {
                    setCooldownSeconds(retryAfter);
                    setCanResend(false);

                    setTimeout(() => {
                        setCanResend(true);
                        setCooldownSeconds(0);
                    }, retryAfter * 1000);
                }
            }
        }
    });

    return {
        ...mutation,
        cooldownSeconds,
        canResend,
        setCooldownSeconds // Allow manual countdown updates
    };
};
